module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/H5YAoa/tc-custom/9781460304907.jpg?1704515156755",
      "alt": "This image is the cover for the book Possession, Bloodties"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Possession, Bloodties\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("My father always said fear was a weakness. Well, that's easy to say when you don't have to worry about vampire slayers or holy water. I hate fear, but undead life goes on. In the two months since I was attacked in the hospital morgue and turned into a vampire, I've killed my evil sire, Cyrus, fallen in love with my new sire, Nathan, and have even gotten used to drinking blood. Just when things are finally returning to normal—as normal as they can be when sunlight can kill you—Nathan becomes possessed.  And then he slaughters an innocent human."), _c('br'), _c('br'), _vm._v("Now it's my job to find Nathan before the Voluntary Vampire Extinction Movement does, because they're just waiting for an excuse to terminate him—"), _c('i', [_vm._v("and")]), _vm._v(" anyone foolish enough to help him. But it gets worse. It turns out that Nathan's been possessed by one of the most powerful and wicked vampires alive—the Soul Eater. And who knows what vile plan he's concocted?"), _c('br'), _c('br'), _vm._v("With the Soul Eater and my possessed sire on the loose, I have a "), _c('i', [_vm._v("lot")]), _vm._v(" to fear. Including being killed. Again.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jennifer Armintrout\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0